export default __webpack_public_path__ + "static/media/panther.0175a926.png";